import {createHtmlElement, restrictUserInteractions} from '../../functions';
import { changeLangToCurrent, getCurrentLangDirection, isDesktopMode } from '../language/langSwitcher';
import gsap from 'gsap';
import {
    changePlaceholder,
    customiseForm,
    initForm,
    moveFormToBlock,
    setPropId,
    setTranslateToSendBtn,
} from '../form/form';
import { applyNow, chatsApplyNow } from '../apply-now/applyNow';
import { applyNowContent } from '../apply-now/applyNowContent';
import TextPlugin from 'gsap/TextPlugin';
import { leftNavigationBar } from '../navigation/left-nav-bar';
import { isMobile, settingsData } from '../../settings';
import { getCookie, setCookie } from '../cookies/setAndGetCookies';
import { analytics } from '../analytics/analytics';
import { openAndCloseAnimation, removeContactUs } from '../contactUs/contactUs';

let contactWidget = null;

export function chatsInit () {
    if (isDesktopMode() && !settingsData.isConferenceHost) return;

    let parent;

    if (settingsData.isConferenceHost && !isDesktopMode()){
        if (isMobile) {
            parent = document.querySelector('.additional-menu__item[data-menu-item="contactWidget"]');
        } else {
            parent = document.querySelector('.aside__container');
        }
    } else if (settingsData.isConferenceHost && isDesktopMode()){
        parent = document.body;
    } else if (isMobile){
        parent = document.querySelector('.additional-menu__item[data-menu-item="contactWidget"]');
    } else {
        parent = document.querySelector('.aside__container');
    }

    contactWidget = new ContactWidget(parent);
    contactWidget.create();
}

export function contactFormChangeLanguage () {
    if (contactWidget) {
        contactWidget.changeLanguage();
    }
}

export function contactToAgentWithWidget (propId) {
    if (contactWidget) {
        contactWidget.contactToAgent(undefined,propId);
    }
}

export function closeContactWidget () {
    if (contactWidget) {
        contactWidget.close();
    }
}


export class ContactWidget {
    #formUsed = ['.contact-us','.apply__main-container:not(.chats)'];
    #defaultAgentName = {
        en: 'Bridget',
        he: "ברידג'ט",
        ru: 'Бриджит'
    };

    constructor (parent, animation = true) {
        this.parent = parent;
        this.animation = animation;
        this.container = null;
        this.widgetBtn = null;
        this.closeBtn = null;
        this.contentContainer = null;
        this.form = null;
        this.opened = false;
        this.consoltoIsActive = settingsData.isConferenceHost || config.contactWidget?.consolto?.active;
        this.consoltoWidget = null;
        this.agentStatus = 'offline';
        this.agentElement = null;
        this.cloneBtn = null;
        this.dropDownClone = null;
        this.applyNow = null;
        this.activeContent = null;
        this.blockEvents = false;
        // this.formUse = config.general.leadForm || settingsData.isConferenceHost;
        this.formUse = true;
        this.imageAgentUrl = config.contactWidget?.agentImageUrl || '../img/online.png';

    }

    async create () {
        if (!config.contactWidget.active && !settingsData.isConferenceHost) return;

        this.container = createHtmlElement(this.parent, '', 'div', ['contact-widget__main-container', 'invisible']);
        this.widgetBtn = createHtmlElement(this.container, isMobile ? '' : changeLangToCurrent('leadFormTitle'), 'div', ['contact-widget__btn']);
        document.documentElement.style.setProperty('--image-agent-url', `url(\'${this.imageAgentUrl}\')`);

        if (!isMobile){
            this.widgetBtn.classList.add('language-string');
            this.widgetBtn.setAttribute('data-dictionary','leadFormTitle');
        }

        if (this.consoltoIsActive) {
            const consoltoScript = createHtmlElement(document.body, '', 'script', []);
            consoltoScript.setAttribute('id', 'et-iframe');
            consoltoScript.setAttribute('data-version', '0.5');

            if (settingsData.isConferenceHost){
                consoltoScript.setAttribute('data-widgetId', config.features.contactWidget.consolto.id);
            } else {
                consoltoScript.setAttribute('data-widgetId', config.contactWidget.consolto.id);
            }

            consoltoScript.setAttribute('src', 'https://client.consolto.com/iframeApp/iframeApp.js');
            this.widgetBtn.classList.add('consolto');
            // this.agentElement = createHtmlElement(this.container,'','div',['consolto__agent__status']);

            window.addEventListener('consoltoEvent', this.addConsoltoEventListener.bind(this));


        }

        this.contentContainer = createHtmlElement(this.container, '', 'div', ['contact-widget__content__container', 'hidden']);
        this.closeBtn = createHtmlElement(this.contentContainer, '', 'div', ['contact-widget__close__btn', 'icon-close']);

        this.closeBtn.addEventListener('click', this.close.bind(this));
        this.widgetBtn.addEventListener('click', this.contactToAgent.bind(this));

        this.cloneBtn = this.widgetBtn.cloneNode(true);
        this.cloneBtn.classList.add('clone');
        this.cloneBtn.textContent = '';

        if (isMobile){
            this.cloneBtn.classList.add('normal__size');
        }

        this.dropDownClone = this.widgetBtn.cloneNode(true);
        this.dropDownClone.classList.add('drop-down__clone');
        this.dropDownClone.textContent = '';
        createHtmlElement(this.dropDownClone,'','span',['drop-down__text','hidden']);

        if (this.formUse){
            // this.form = await initForm(this.contentContainer);
            // setTranslateToSendBtn(this.form);
            // changePlaceholder(this.form);

            this.form = createHtmlElement(this.contentContainer,'','div',['chats__form']);
            this.form.insertAdjacentElement('afterbegin',this.cloneBtn);
            this.form.classList.add('hidden');
        }


        // const nextBtn = createHtmlElement(this.form.querySelector('.btn'), '', 'input', ['button', 'language-string']);
        // nextBtn.type = 'button';
        // nextBtn.value = changeLangToCurrent('Next');
        // nextBtn.setAttribute('data-dictionary', 'Next');
        // nextBtn.addEventListener('click', this.contactToAgent.bind(this));

        this.applyNow = chatsApplyNow(this.contentContainer, applyNowContent);
        this.applyNow.insertAdjacentElement('afterbegin',this.cloneBtn.cloneNode(true));

        const showDate = getCookie('contactWidgetShowDate');
        let text;
        const agentNames = { agentName: {} };

        config.contactWidget.agentName.forEach(name => {
            if (name.value) {
                agentNames.agentName[name.lang] = name.value;
            } else {
                agentNames.agentName[name.lang] = this.#defaultAgentName[name.lang];
            }
        });

        if (!showDate){
            setCookie('contactWidgetShowDate',Date.now());
            text = changeLangToCurrent('contactWidgetWelcomeText',[agentNames]);
        } else {
            const dateFrom = Number(showDate);
            const expiredDate = dateFrom + 2629800000;

            if (Date.now() > expiredDate){
                text = changeLangToCurrent('contactWidgetWelcomeText',[agentNames]);
            } else {
                text = changeLangToCurrent('contactWelcomeText2');
            }

        }

        this.showWidget(text);
    }

    getForm(propId){
        let activeElement = false;

        this.#formUsed.forEach(query => {
           const form = document.querySelector(query)?.querySelector('.form__container-main');

           if (form) {
               activeElement = query;
           }
        });

        switch (activeElement) {
            case '.contact-us':
                removeContactUs();
                moveFormToBlock(this.form);

                break;

            case '.apply__main-container:not(.chats)':
                moveFormToBlock(this.form);
                const applyContainer = document.querySelector('.apply__main-container:not(.chats)');
                applyContainer.remove();
                break;

            default:
                moveFormToBlock(this.form);

                break;

        }

        this.#customiseForm(propId);
    }

    addConsoltoEventListener (e) {
        if (e.detail.consoltoReady) {
            this.consoltoWidget = new CustomEvent('consolto_h2w', {
                detail: {
                    'et-click-type': 'open-widget',
                },
            });
        }

        if (e.detail?.action === 'AVAILABILITY_STATE_CHANGE') {
            this.changeAgentStatus(e.detail.value);
            this.changeButtonTitle();
        }

        if (e.detail?.action === 'OPEN_WIDGET'){
            this.btnVisibleToggle('hide');
        }

        if (e.detail?.action === 'CLOSE_WIDGET'){
            this.btnVisibleToggle('show');
        }

        if (e.detail?.action === 'CALL_STARTED_CLIENT'){
            analytics('call_start');
        }

    }

    changeAgentStatus (status) {
        this.agentStatus = status;
        // this.agentElement.className = `consolto__agent__status ${status}`;
        // this.widgetBtn.className = `contact-widget__btn consolto ${status}`;

        if (isMobile){
            this.cloneBtn.className = `contact-widget__btn consolto clone normal__size ${status}`;
            this.widgetBtn.className = `contact-widget__btn consolto ${status}`;
        } else {
            this.cloneBtn.className = `contact-widget__btn consolto clone ${status}`;
            this.widgetBtn.className = `contact-widget__btn language-string consolto ${status}`;
        }
    }

    changeButtonTitle() {
        if (isMobile)
            return;

        switch (this.agentStatus) {
            case 'offline':
                this.widgetBtn.innerHTML = changeLangToCurrent('contactUs');
                this.widgetBtn.setAttribute('data-dictionary','contactUs');
                break;
            case 'available':
                this.widgetBtn.innerHTML = changeLangToCurrent('leadFormTitle');
                this.widgetBtn.setAttribute('data-dictionary','leadFormTitle');
                break;
            // case 'busy':
            //     break;
            default:
                console.log('ContactWidget:ChangeButtonTitle:Default case triggered');
                break;
        }
    }

    btnVisibleToggle(action){
        switch (action) {
            case 'show':
                this.widgetBtn.style.visibility = 'visible';
                break;
            case 'hide':
                this.widgetBtn.style.visibility = 'hidden';
                break;
        }
    }

    #customiseForm(propId){
        if (!config.general.leadForm && !settingsData.isConferenceHost)  return;

        this.form.querySelector('input[type="email"]').parentElement.classList.add('hidden');

        if (propId){
            setPropId(this.form, propId);
        }
    }

    contactToAgent (e,propId) {
        if (e?.target?.classList?.contains('contact-widget__btn') && this.opened){
            return;
        }

        if (this.consoltoIsActive) {

            if (this.isFormSend()){

                if (this.opened){
                    this.close();
                }

                this.openConsoltoWidget();

            } else {

                if (this.formUse) {
                    this.getForm(propId);
                    this.activeContent = this.form;
                    this.open();
                } else {
                    this.openConsoltoWidget();
                }
                // if (this.opened){
                //     this.openConsoltoWidget();
                // } else {
                //
                // }
            }

            /*switch (this.agentStatus) {
                case 'offline':

                    if (this.opened) {
                        this.showApplyNow();

                    } else {

                        if (this.isFormSend()) {
                            this.activeContent = this.applyNow;
                            this.open();
                        } else {
                            this.activeContent = this.form;
                            this.open();
                        }
                    }
                    break;

                case 'available':

                    if (this.isFormSend()){

                        if (this.opened){
                            this.close();
                        }

                        this.openConsoltoWidget();

                    } else {

                       if (this.opened){
                           this.openConsoltoWidget();
                       } else {
                           this.activeContent = this.form;
                           this.open();
                       }

                    }
                    break;

                case 'busy':

                    if (this.opened) {
                        this.showApplyNow();

                    } else {

                        if (this.isFormSend()) {
                            this.activeContent = this.applyNow;
                            this.open();
                        } else {
                            this.activeContent = this.form;
                            this.open();
                        }
                    }
                    break;

            }*/

        } else {

            if (this.isFormSend()) {

                if (this.opened){
                    this.showApplyNow();
                } else {
                    this.activeContent = this.applyNow;
                    this.open();
                }

            } else {

                if (this.formUse){
                    this.getForm(propId);
                    this.activeContent = this.form;
                } else {
                    this.activeContent = this.applyNow;
                }

                this.open();
            }


            // if (this.opened) {
            //
            //     this.showApplyNow();
            //
            // } else {
            //
            //     if (this.isFormSend()) {
            //         this.activeContent = this.applyNow;
            //         this.open();
            //     } else {
            //         this.activeContent = this.form;
            //         this.open();
            //     }
            // }

        }

    }

    openConsoltoWidget () {
        window.dispatchEvent(this.consoltoWidget);
    }

    showApplyNow () {
        if (this.activeContent === this.applyNow) return;

        const tl = gsap.timeline({
            onComplete: () => {
                this.activeContent = this.applyNow;
            },
        });

        if (this.widgetBtn.style.visibility === 'hidden'){
            this.widgetBtn.style.visibility = 'visible';
        }


        tl.fromTo(this.form, {
            transform: 'rotateY(0)',
        }, {
            transform: 'rotateY(90deg)',
            duration: .2,
            onComplete: () => {
                this.form.classList.add('hidden');
                this.applyNow.classList.remove('hidden');

                tl.fromTo(this.applyNow, {
                    transform: 'rotateY(-90deg)',
                }, {
                    transform: 'rotateY(0)',
                    duration: .2,
                });
            },
        });
    }

    open () {
        if (this.opened) return;
        if (this.blockEvents) return;

        this.blockEvents = true;
        this.resetStyle();

        this.activeContent.classList.remove('hidden');

        const tl = gsap.timeline({
            onComplete: () => {
                this.opened = true;
                this.blockEvents = false;
            },
        });

        this.contentContainer.classList.remove('hidden');

        // tl.fromTo(this.contentContainer, {
        //     height: 0,
        // }, {
        //     height: 'auto',
        //     duration: .5,
        //     onStart: () => {
        //         if (this.activeContent === this.form){
        //             this.widgetBtn.style.visibility = 'hidden';
        //         }
        //         this.contentContainer.style.padding = '';
        //     },
        // });

        tl.fromTo(this.contentContainer, {
            transform: `translate(50%, 50%) scale(0)`
        }, {
            transform: `translate(0) scale(1)`,
            duration: .5,
            onStart: () => {
                // if (this.activeContent === this.form){
                this.btnVisibleToggle('hide');
                // this.widgetBtn.style.visibility = 'hidden';
                // }
                this.contentContainer.style.padding = '';
            },
        });


        tl.fromTo([this.activeContent, this.closeBtn], {
            opacity: 0,
        }, {
            opacity: 1,
            duration: .8,
        });
    }

    resetStyle () {
        this.applyNow.classList.add('hidden');
        this.applyNow.style.opacity = '';
        this.applyNow.style.transform = '';

        if (this.formUse){
            this.form.classList.add('hidden');
            this.form.style.opacity = '';
            this.form.style.transform = '';
        }

        this.contentContainer.style.transform = '';
        this.contentContainer.style.height = '';
    }

    close () {
        if (!this.opened || this.blockEvents) return;

        this.blockEvents = true;

        this.contentContainer.classList.add('hidden');
        this.opened = false;
        // this.widgetBtn.style.visibility = 'visible';
        this.btnVisibleToggle('show');
        this.blockEvents = false;
        this.resetStyle();


        // const tl = gsap.timeline({
        //     onComplete: () => {
        //         this.opened = false;
        //         this.widgetBtn.style.visibility = 'visible';
        //         this.blockEvents = false;
        //         this.resetStyle();
        //     },
        // });
        //
        // tl.fromTo([this.activeContent, this.closeBtn], {
        //     opacity: 1,
        // }, {
        //     opacity: 0,
        //     duration: .5,
        //     onComplete: () => {
        //         this.contentContainer.style.padding = 0;
        //     },
        // });
        //
        // tl.to(this.contentContainer, {
        //     height: 0,
        //     duration: .8,
        //     onComplete: () => {
        //         this.contentContainer.classList.add('hidden');
        //     },
        // });

    }

    isFormSend () {
        const sendDate = getCookie('contactFormSend');

        if (sendDate){
            const parseSendDate = Number(sendDate);
            const expiredDate = parseSendDate + 2629800000;

            return Date.now() <= expiredDate;

        } else {

            return false;
        }
    }

    changeLanguage () {
        if (!this.form) return;

        setTranslateToSendBtn(this.form);
        changePlaceholder(this.form);
    }

    showWidget (text) {
        if (!this.animation) {
            this.container.classList.remove('hidden','invisible');

            return;
        }

        const dir = getCurrentLangDirection();
        const side =  isDesktopMode() || isMobile ? 0 : dir === 'rtl' ? -100 : 100;
        const avatarSize = isMobile ? 10 : 80;
        const topDropDown = isMobile ? settingsData.isLandscape ? 10 : 100 : 200;
        const diff = isMobile ? 8 : 5;
        const scale = isMobile ? 0.25 : 0.5;

        gsap.registerPlugin(TextPlugin);

        const tl = gsap.timeline();

        document.body.appendChild(this.dropDownClone);

        this.dropDownClone.addEventListener('click', () => {
            tl.clear();

            this.#hideText(tl, 0);
            this.#flyToWidget(tl, avatarSize, diff, scale);
        });

        // Drop down
        tl.to(this.dropDownClone,{
            transform: `translate(${window.innerWidth / 2 + side}px, ${topDropDown}px)`,
            left: 0,
            top: 0,
            duration: .5
        });

        // Print
        tl.to(this.dropDownClone.querySelector('.drop-down__text'),{
            text: text,
            duration: Math.ceil(text.split(' ').length / 4),
            // duration: 1,
            onStart: () => {
                this.dropDownClone.querySelector('.drop-down__text').classList.remove('hidden');
            }
        });

        this.#hideText(tl);
        this.#flyToWidget(tl, avatarSize, diff, scale);

        // gsap.fromTo(this.container, {
        //     [side]: -300,
        // }, {
        //     [side]: 20,
        //     delay: 2,
        //     duration: 1,
        //     onStart: () => {
        //         this.container.classList.remove('hidden');
        //     },
        //     onComplete: () => {
        //         this.container.style[side] = '';
        //     },
        // });
    }

    #flyToWidget(tl, avatarSize, diff, scale) {
        const containerPosition = this.container.getBoundingClientRect();
        tl.to(this.dropDownClone, {
            transform: `translate(${containerPosition.x + avatarSize + diff}px,${containerPosition.y - avatarSize + diff}px) scale(${scale})`,
            duration: 1,
            onComplete: () => {
                this.container.classList.remove('hidden','invisible');
                this.dropDownClone.remove();
                this.dropDownClone = null;

                restrictUserInteractions(false);
            }
        })
    }

    #hideText(tl, delay = 2.5) {
        tl.to(this.dropDownClone.querySelector('.drop-down__text'),{
            opacity: 0,
            duration: .2,
            delay: delay,
            onComplete: () => this.dropDownClone.querySelector('.drop-down__text').classList.add('hidden')
        });
    }
}
